import {
  AppBar,
  Box,
  Button,
  Grid,
  makeStyles,
  Paper,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import KenCardWithoutpadding from '../../../../../../global_components/KenCard/KenCard2';
import KenDialogBox from '../../../../../../global_components/KenDialogBox';
import PropTypes from 'prop-types';
import KenSelectWrap from '../../../../../../global_components/KenSelect';
import KenCard from '../../../../../../global_components/KenCard';
import GradingSelection from './Absolute/GradingSelection';
import GradingSelectionForRelative from './Relative/GradingSelectionForRelative';
import GradingDetails2 from '../GradingDetails2';
import { useParams } from 'react-router-dom';
import GradingStatsAbsulate from './GradingStats/GradingStatsAbsulate';
import GradingStatsRelative from './GradingStats/GradingStatsRelative';
import '../../../../../../style/index.css';
import EvaluationSubcomponents from './Evaluation Subcomponents/EvaluationSubcomponents';
import {
  getGradingDetails,
  postEvaluationDetailsData,
  postSubjectDetails,
} from '../../../../../../Utils/apiServices';
import history from '../../../../../../Utils/history';
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    height: '28px',
    width: '78px',
    textDecoration: 'none',
    textTransform: 'none',
    borderBottom: '1px solid transparent',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid transparent',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  normal: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  editbtn: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '#00218D',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '70%',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  table: {
    minWidth: 700,
    padding: 10,
  },
  tbCourseTerm: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '100%',
    color: '#02195E',
  },
  containerModify: {
    marginTop: 16,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
    flex: 1,
    overflowY: 'scroll',
    overflowX: 'hidden',
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    minHeight: '55vh',
    maxHeight: '65vh',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      opacity: '0.2',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#C4C4C4',
      borderRadius: '30px',
      opacity: '0.1',
      outline: `1px solid transparent`,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: `#02195E`,
    },
  },
  selectGrading: {
    marginTop: '20px',
    marginLeft: '-32px',
  },
  selectGradingTitle: {
    marginTop: '16px',

    fontSize: '14px',
    fontWeight: 'bolder',
    lineHeight: '38px',
    textTransform: 'uppercase',
    marginLeft: '30px',
  },
  hr: {
    marginBottom: '-1px',
  },
}));

const selectOptionsCourse = [
  {
    label: 'ABSOLUTE',
    value: 'Absolute',
  },
  {
    label: 'RELATIVE',
    value: 'Relative',
  },
];
const GradingDetails = () => {
  const classes = useStyles();
  const theme = useTheme();

  const paramId = useParams();
  const [rows, setRows] = useState([
    // {
    //   id: 1,
    //   studentName: 'Test Student Record 60',
    //   finalMidtermMarks: 70,
    //   finalEndTermMarks: 75,
    //   finalTotalMarks: 70,
    //   calculatedGrade: 'A',
    //   penalties: 'NA',
    //   finalGrade: 'A',
    //   quiz1: 10,
    //   quiz2: 16,
    //   project1: 10,
    //   project2: 8,
    //   assignment1: 14,
    //   assignment2: 15,
    // },
    // {
    //   id: 2,
    //   studentName: 'Test Student Record 71',
    //   finalMidtermMarks: 71,
    //   finalEndTermMarks: 76,
    //   finalTotalMarks: 71,
    //   calculatedGrade: 'A',
    //   penalties: 'NA',
    //   finalGrade: 'A',
    //   quiz1: 15,
    //   quiz2: 15,
    //   project1: 8,
    //   project2: 10,
    //   assignment1: 14,
    //   assignment2: 14,
    // },
    // {
    //   id: 3,
    //   studentName: 'Test Student Record 11',
    //   finalMidtermMarks: 71,
    //   finalEndTermMarks: 77,
    //   finalTotalMarks: 72,
    //   calculatedGrade: 'B+',
    //   penalties: 'NA',
    //   finalGrade: 'B+',
    //   quiz1: 18,
    //   quiz2: 20,
    //   project1: 12,
    //   project2: 10,
    //   assignment1: 13,
    //   assignment2: 14,
    // },
    // {
    //   id: 4,
    //   studentName: 'Test Student Record 24',
    //   finalMidtermMarks: 90,
    //   finalEndTermMarks: 80,
    //   finalTotalMarks: 84,
    //   calculatedGrade: 'A+',
    //   penalties: 'NA',
    //   finalGrade: 'A+',
    //   quiz1: 20,
    //   quiz2: 15,
    //   project1: 10,
    //   project2: 10,
    //   assignment1: 15,
    //   assignment2: 14,
    // },
    // {
    //   id: 5,
    //   studentName: 'Test Student Record 32',
    //   finalMidtermMarks: 80,
    //   finalEndTermMarks: 90,
    //   finalTotalMarks: 84,
    //   calculatedGrade: 'A+',
    //   penalties: 'NA',
    //   finalGrade: 'A+',
    //   quiz1: 15,
    //   quiz2: 20,
    //   project1: 8,
    //   project2: 10,
    //   assignment1: 17,
    //   assignment2: 14,
    // },
  ]);
  const [previous, setPrevious] = useState({});
  const [loading, setLoading] = React.useState(false);

  const [sliderDialog, setSliderDialog] = useState(false);
  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  function handleSliderDialog() {
    setSliderDialog((prevState) => !prevState);
  }

  const handleClickSlider = () => {
    handleSliderDialog();
  };
  function positiveClick() {
    setSliderDialog((prevState) => !prevState);
  }

  const [value, setValue] = React.useState(0);

  const handleOnTabsChanges = (event, newValue) => {
    setValue(newValue);
  };

  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    setRows((state) => {
      return newData.map((row) => {
        console.log('rowioioiiorowrowoioiorow', { row }, id);
        if (row.id === id) {
          if (check === 'done') {
            row.isEditMode = true;
            return { ...row, isEditMode: !row.isEditMode };
          }
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
        }
        return row;
      });
    });
  };

  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  //For Grading system
  const onDataSave = () => {
    const newData = [...rows];

    const payload = newData.map((row) => {
      return {
        // id: row.id,
        // passFailStatus: null,
        // gradePoint: row.gradePoint,
        // finalLetterGrade: row.finalGrade,
        // penalty: row.penalties,
        // calculatedLetterGrade: row.calculatedGrade,
        // creditsEarned: null,
        // marksObtained: null,
        // maximumMarks: null,
        // term: row.term,
        // courseOfferingId: row.courseOfferingId,
        // courseConnectionId: row.courseConnectionId,
        // studentId: row.studentId,

        id: row.id,
        // TotalMarksObtained: parseFloat(row.finalTotalMarks),
        CalculatedGrade: row.calculatedGrade,
        penality: row.penalties.toString(),
        finalGrade: row.finalGrade,
      };
    });
    postSubjectDetails(payload, paramId.id)
      .then((res) => {
        console.log('res', res);
        getGradingDetailsData();
      })
      .catch((err) => {
        console.log('errerrerrerrerrerr', err);
        alert('Failed to add. Please try again.');
      });
  };
  const getGradingDetailsData = () => {
    setLoading(true);
    getGradingDetails(paramId.id)
      .then((res) => {
        setLoading(false);
        // const dataList = [];
        // for (let value of Object.entries(res[0]?.studentList[0])) {
        //   dataList.push({ ...value[1], rollNumber: value[0] });
        // }
        console.log('dataList', res);
        const datas =
          res === null
            ? []
            : res.map((item) => {
                console.log('itemitemitemitemitem', item);
                return {
                  id: item.id ? item.id : '-',
                  studentName: item.studentName ? item.studentName : '-',
                  finalMidtermMarks: item.componentList[2]?.marksObtained
                    ? item.componentList[2]?.marksObtained
                    : '-',
                  finalEndTermMarks: item.componentList[4]?.marksObtained
                    ? item.componentList[4]?.marksObtained
                    : '-',
                  finalTotalMarks: item.marksObtained
                    ? item.marksObtained
                    : '-',
                  calculatedGrade: item.calculatedLetterGrade
                    ? item.calculatedLetterGrade
                    : '-',
                  penalties: item?.penalty ? item?.penalty : '-',
                  finalGrade: item?.finalLetterGrade
                    ? item?.finalLetterGrade
                    : '-',
                  quiz1: item?.componentList
                    ? item.componentList[1]?.subCompList[0]?.marksObtained
                    : '-',
                  quiz2: item?.componentList
                    ? item.componentList[1]?.subCompList[1]?.marksObtained
                    : '-',
                  project1: item?.componentList
                    ? item.componentList[3]?.subCompList[0]?.marksObtained
                    : '-',
                  project2: item?.componentList
                    ? item.componentList[3]?.subCompList[1]?.marksObtained
                    : '-',
                  assignment1: item?.componentList
                    ? item.componentList[5]?.subCompList[0]?.marksObtained
                    : '-',
                  assignment2: item?.componentList
                    ? item.componentList[5]?.subCompList[1]?.marksObtained
                    : '-',
                  term: item.term,
                  studentId: item.studentId,
                  courseOfferingId: item.courseOfferingId,
                  courseConnectionId: item.courseConnectionId,
                  gradePoint: item.gradePoint,
                };
              });

        // setRows(datas);
        setLoading(false);
      })
      .catch((err) => {
        console.log('grading error', err);
      });
  };
  // console.log('rowrowrowrowrowrow', rows);
  // useEffect(() => {
  //   getGradingDetailsData();
  // }, [rows]);

  return (
    <div>
      {' '}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Grading
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Typography
              style={{
                marginRight: '25px',
                fontWeight: 'bold',
                paddingTop: '10px',
                color: '#505f81',
              }}
            >
              No of student:{rows.length}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{
                marginRight: '15px',
                background: '#272727 !important',
                color: 'white',
              }}
              onClick={() => history.goBack()}
              className={classes.addButton}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleClickSlider}
            >
              Edit Grading Details
            </Button>

            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={onDataSave}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <KenDialogBox
        title={
          <Typography variant="p" style={{ textAlign: 'center' }}>
            Grading Setting
          </Typography>
        }
        open={sliderDialog}
        handleClose={() => handleSliderDialog()}
        negativeButtonClick={() => handleSliderDialog()}
        positiveButtonClick={() => positiveClick()}
        hidePositiveButton={true}
        // hideNegativeButton={true}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        maxWidth="ls"
        dividers
      >
        {' '}
        <KenCardWithoutpadding className="aaa">
          <Grid container>
            <Grid xs={2}>
              {' '}
              <Typography className={classes.selectGradingTitle}>
                {' '}
                Select Grading:
              </Typography>
            </Grid>
            <Grid className={classes.selectGrading} xs={10}>
              {' '}
              <KenSelectWrap
                options={selectOptionsCourse}
                value={selectValueCourse}
                dropdownColor="#FFFFFF"
                onChange={handleSelectChangeCourse}
                required
              />{' '}
            </Grid>
          </Grid>

          <hr className={classes.hr} />
          <div className={classes.root}>
            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel
                color="default"
                value={value}
                index={0}
                dir={theme.direction}
                className="grading-model"
              >
                <Box className="cardlsitbox">
                  {/* <KenCard>
                    <Typography>{selectValueCourse} Grading </Typography>
                  </KenCard> */}

                  {selectValueCourse === 'Absolute' ? (
                    <>
                      <GradingSelection />
                    </>
                  ) : (
                    <GradingSelectionForRelative />
                  )}
                </Box>
              </TabPanel>
              {/* <TabPanel value={value} index={1} dir={theme.direction}>
                {selectValueCourse === 'Absolute' ? (
                  <>
                    <GradingStatsAbsulate courseOfferingId={paramId.id} />
                  </>
                ) : (
                  <GradingStatsRelative courseOfferingId={paramId.id} />
                )}
              </TabPanel> */}
              <TabPanel
                className="tab-panel-size"
                value={value}
                index={1}
                dir={theme.direction}
              >
                <EvaluationSubcomponents />
              </TabPanel>
            </SwipeableViews>
          </div>
        </KenCardWithoutpadding>
      </KenDialogBox>
      <Paper>
        <GradingDetails2
          gradingId={paramId.id}
          rows={rows}
          setRows={setRows}
          onChange={onChange}
          onToggleEdit={onToggleEdit}
          onRevert={onRevert}
          onToggleEditMode={onToggleEditMode}
          onDataSave={onDataSave}
          getGradingDetailsData={getGradingDetailsData}
          loading={loading}
          setLoading={setLoading}
        />
      </Paper>
    </div>
  );
};

export default GradingDetails;
